// extracted by mini-css-extract-plugin
module.exports = {"Loader":"spinner_Loader__3W8a6","load6":"spinner_load6__2D4w5","round":"spinner_round__2RnKG"};